import styled from '@emotion/styled';
import { GlobalScore, Model } from '@gameonly/core';
import { useTranslation } from 'react-i18next';
import { Text } from './layout';
import { DARK_BLUE } from './colors';
import BaseMarkdown from '../ui/Markdown';
import { StringExpressionOperator } from 'mongoose';

const MainContainer = styled.div`
  width: 100%;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 40px 100%, 0 calc(100% - 40px));
`;

const TopSection = styled.div`
  border-radius: 0;
  margin: 2.5rem 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const LeftColumn = styled.div`
  min-width: 340px;
  max-width: 50%;
`;

const TitleText = styled(Text)`
  font-size: 2rem;
  font-weight: bold;
  color: #fff;
  font-family: Ibrand, sans-serif;
  text-transform: uppercase;
  border-left: 4px solid #fff;
  padding-left: 1rem;
  margin-bottom: 1.5rem;
  letter-spacing: 0;
  text-align: left;
`;

const ScoreBox = styled.div`
  display: inline-block;
  padding: 0.7rem 2.5rem;
  margin-top: 0.5rem;
`;

const ScoreText = styled(Text)`
  font-size: 2.5rem;
  font-weight: bold;
  color: #23233D;
  font-family: Causten, sans-serif;
  text-transform: uppercase;
  letter-spacing: 0;
`;

const RightColumn = styled.div`
  max-width: 45%;
  text-align: right;
  color: #fff;
  font-size: 1rem;
  font-family: Causten, sans-serif;
  margin-top: 0.5rem;
  background: #fff;
  color: #23233D;
  height: 100%;
  padding: 3rem 2rem;
  text-align: left;
`;

const BottomSection = styled.div`
  border-radius: 0;
  margin-top: 0;
  padding: 1.5rem 2.5rem;
`;

const Markdown = styled(BaseMarkdown)`
  font-size: 1rem;
  font-family: Causten, sans-serif;
  margin-top: 0.5rem;
    white-space: normal;

  p {
    font-size: 1rem;
    white-space: pre-wrap;
  }

  h1 {
    font-size: 2rem;
    color: ${DARK_BLUE};
    text-transform: uppercase;
    border-left: 4px solid ${DARK_BLUE};
    font-family: Ibrand, sans-serif;
    padding-left: 1rem;
    letter-spacing: 0;
  }

  h2 {
    margin-top: 1rem;
    font-size: 1.2rem;
    font-weight: normal;
    color: #fff;
    font-family: Ibrand, sans-serif;
  }
`;


export const PdfGlobalScore = ({
  title,
  score,
  unit,
  text,
  definition,
  scoreBlockStyle,
  definitionBlockStyle,
}: {
  title: string;
  score: string;
  unit: string;
  text: string;
  definition: string;
  scoreBlockStyle?: React.CSSProperties;
  definitionBlockStyle?: React.CSSProperties;
}) => {
  return (
    <MainContainer>
      <TopSection>
        <LeftColumn>
          <TitleText>{title}</TitleText>
          <ScoreBox style={scoreBlockStyle}>
            <ScoreText>{score} {unit}</ScoreText>
          </ScoreBox>
        </LeftColumn>
        <RightColumn>
          {text}
        </RightColumn>
      </TopSection>
      <BottomSection style={definitionBlockStyle}>
        {definition && (
          <Markdown>{definition}</Markdown>
        )}
      </BottomSection>
    </MainContainer>
  );
};
